export const AUDIT_SECTION_LIST = 'AUDIT_SECTION_LIST';
export const STATUS_UPDATE = 'STATUS_UPDATE';
export const LIST_UPDATE = 'LIST_UPDATE';
export const AUDIT_LOADER = 'AUDIT_LOADER';
export const FETCH_FILE_LIST = 'FETCH_FILE_LIST';
export const LINKED_DOCS_EMPTY = 'LINKED_DOCS_EMPTY';
